import { CONFIG_STORAGE_KEY } from "./load";
import type { ConfigLayer } from "./types";
import { validateLayer } from "./validate";

interface Storage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

/** This browser's connection settings (the "settings" config layer), validated. */
export function readSettings(storage: Storage | null | undefined): ConfigLayer {
  try {
    const raw = storage?.getItem(CONFIG_STORAGE_KEY);
    return raw ? validateLayer(JSON.parse(raw)) : {};
  } catch {
    return {};
  }
}

/**
 * Saves connection settings in this browser only (they're never shared: room links carry
 * signaling relays at most, never ICE servers or TURN credentials). An empty layer clears them.
 * Returns what was kept after validation.
 */
export function writeSettings(
  storage: Storage | null | undefined,
  layer: ConfigLayer,
): ConfigLayer {
  const valid = validateLayer(layer);
  try {
    if (Object.keys(valid).length === 0) storage?.removeItem(CONFIG_STORAGE_KEY);
    else storage?.setItem(CONFIG_STORAGE_KEY, JSON.stringify(valid));
  } catch {}
  return valid;
}
